function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 9,
  fill: "#789EFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2729 11.7698L9.50365 9.00062L12.2729 6.23142C12.3396 6.16465 12.3771 6.0741 12.3771 5.97967C12.3771 5.88525 12.3396 5.7947 12.2729 5.72793C12.2061 5.66116 12.1155 5.62365 12.0211 5.62365C11.9267 5.62365 11.8361 5.66116 11.7694 5.72793L9.00016 8.49712L6.23097 5.72793C6.1642 5.66116 6.07365 5.62365 5.97922 5.62365C5.8848 5.62365 5.79425 5.66116 5.72748 5.72793C5.69352 5.75941 5.6667 5.79779 5.64883 5.84051C5.63096 5.88323 5.62245 5.92928 5.62389 5.97556C5.62532 6.02184 5.63665 6.06728 5.65713 6.10881C5.6776 6.15034 5.70674 6.187 5.74258 6.21632L8.51178 8.98551L5.72748 11.7698C5.66071 11.8366 5.6232 11.9271 5.6232 12.0216C5.6232 12.116 5.66071 12.2065 5.72748 12.2733C5.79425 12.3401 5.8848 12.3776 5.97922 12.3776C6.07365 12.3776 6.1642 12.3401 6.23097 12.2733L9.00016 9.50411L11.7694 12.2733C11.8361 12.3401 11.9267 12.3776 12.0211 12.3776C12.1155 12.3776 12.2061 12.3401 12.2729 12.2733C12.3396 12.2065 12.3771 12.116 12.3771 12.0216C12.3771 11.9271 12.3396 11.8366 12.2729 11.7698Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 1.5
});

function SvgRemoveFileicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFileicon);
export default __webpack_public_path__ + "static/media/remove-file.icon.945fef2d.svg";
export { ForwardRef as ReactComponent };